import { useQuery } from 'react-query';
import { useAccountStore } from '../components/Stores/accountStore';
import { getTransactionsById } from '../sp-firebase/transactionBackTestFB';

const fetchTransactionByAccount = async (accountId: string) => {
  if (!accountId) return;
  try {
    const transactions = await getTransactionsById(accountId);
    if (transactions) {
      return transactions;
    }
    throw new Error('Failed to fetch transactions');
  } catch (error) {
    console.error('Error fetching transactions:', error);
    throw error;
  }
};

export const useTransaction = () => {
  const { account } = useAccountStore();

  const fetchFunction = () => fetchTransactionByAccount(account.id || '');

  // Add account.id to the queryKey so the query refetches whenever it changes
  return useQuery(['transaction', account.id], fetchFunction, {
    enabled: !!account.id, // Only fetch if account.id exists
  });
};
